var _style, _defs, _defs2, _defs3, _defs4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogle = function SvgGoogle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65.7 65.8",
    style: {
      enableBackground: "new 0 0 65.7 65.8"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.googlesvg0{clip-path:url(#SVGID_00000033346649850376684910000006787405773387230597_);fill:#FBBC05;}\n\t.googlesvg1{clip-path:url(#SVGID_00000113314296214906131870000012344251083870881703_);fill:#EA4335;}\n\t.googlesvg2{clip-path:url(#SVGID_00000053543263098463722130000009560811952541655938_);fill:#34A853;}\n\t.googlesvg3{clip-path:url(#SVGID_00000081607628950722816760000001211514801578274205_);fill:#4285F4;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M64,27H33.6v12.6h17.5c-1.6,8-8.4,12.6-17.5,12.6c-10.7,0-19.3-8.6-19.3-19.3s8.6-19.3,19.3-19.3 c4.6,0,8.7,1.6,12,4.3l9.5-9.5c-5.8-5-13.2-8.1-21.5-8.1C15.5,0.3,1,14.8,1,32.9s14.5,32.6,32.6,32.6c16.3,0,31.1-11.9,31.1-32.6 C64.7,31,64.4,28.9,64,27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047053869607655917030000011271844675929911736_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047053869607655917030000011271844675929911736_)",
      fill: "#FBBC05"
    },
    d: "M-2,52.2V13.6 l25.2,19.3L-2,52.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000065765625253963166980000014498762304196877744_",
    d: "M64,27H33.6v12.6h17.5c-1.6,8-8.4,12.6-17.5,12.6 c-10.7,0-19.3-8.6-19.3-19.3s8.6-19.3,19.3-19.3c4.6,0,8.7,1.6,12,4.3l9.5-9.5c-5.8-5-13.2-8.1-21.5-8.1C15.5,0.3,1,14.8,1,32.9 s14.5,32.6,32.6,32.6c16.3,0,31.1-11.9,31.1-32.6C64.7,31,64.4,28.9,64,27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009549085325375498080000011781293128736618626_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065765625253963166980000014498762304196877744_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000009549085325375498080000011781293128736618626_)",
      fill: "#EA4335"
    },
    d: "M-2,13.6l25.2,19.3 l10.4-9l35.6-5.8V-2.7H-2V13.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000007387201576458489200000015494204686447782079_",
    d: "M64,27H33.6v12.6h17.5c-1.6,8-8.4,12.6-17.5,12.6 c-10.7,0-19.3-8.6-19.3-19.3s8.6-19.3,19.3-19.3c4.6,0,8.7,1.6,12,4.3l9.5-9.5c-5.8-5-13.2-8.1-21.5-8.1C15.5,0.3,1,14.8,1,32.9 s14.5,32.6,32.6,32.6c16.3,0,31.1-11.9,31.1-32.6C64.7,31,64.4,28.9,64,27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162350095283366043460000004060248886285650090_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000007387201576458489200000015494204686447782079_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162350095283366043460000004060248886285650090_)",
      fill: "#34A853"
    },
    d: "M-2,52.2l44.5-34.1 l11.7,1.5l15-22.2v71.1H-2V52.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000169553460737594008770000006105175025817616521_",
    d: "M64,27H33.6v12.6h17.5c-1.6,8-8.4,12.6-17.5,12.6 c-10.7,0-19.3-8.6-19.3-19.3s8.6-19.3,19.3-19.3c4.6,0,8.7,1.6,12,4.3l9.5-9.5c-5.8-5-13.2-8.1-21.5-8.1C15.5,0.3,1,14.8,1,32.9 s14.5,32.6,32.6,32.6c16.3,0,31.1-11.9,31.1-32.6C64.7,31,64.4,28.9,64,27z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176740877263767959480000014956256732104296846_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169553460737594008770000006105175025817616521_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000176740877263767959480000014956256732104296846_)",
      fill: "#4285F4"
    },
    d: "M69.2,68.5L23.2,32.9 l-5.9-4.4l51.9-14.8V68.5z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "google.cf28bb1036a872fc455fa67e53559ca6.svg";